import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/vhe/auxiliaries2/correctiveMaintenance/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/vhe/auxiliaries2/correctiveMaintenance/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/vhe/auxiliaries2/correctiveMaintenance/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries2/correctiveMaintenance/create`,  data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries2/correctiveMaintenance/update`,  data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries2/correctiveMaintenance/delete/${id}`)
    },
}